/* unplugin-vue-components disabled */import { render } from "./search.vue?vue&type=template&id=4d5170b2&scoped=true&ts=true"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"

import "./search.vue?vue&type=style&index=0&id=4d5170b2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\17532\\Desktop\\智慧校园\\school-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5170b2"]])

export default __exports__